import React from "react";
import PropTypes from "prop-types";

import { ColorPicker, FontPicker, SelectInput } from "../../../../../shared/Forms";
import { renderFields } from "../helper";

const NavBar = () => {
	const options = ["auto", "left", "right", "center"];
	let values = options.map(option => {
		return { key: option, value: option, label: option.charAt(0).toUpperCase() + option.slice(1) };
	});

	const fields = [
		<ColorPicker field="color" id="color" placeholder="Color" themeBuilderInputType="ColorPicker" />,
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FontPicker field="family" id="family" placeholder="Font Family" themeBuilderInputType="FontPicker" />,
		<SelectInput
			field="alignment"
			id="alignment"
			placeholder="Title Alignment"
			values={values}
			themeBuilderInputType="SelectInput"
		/>,
	];

	return (
		<div className="theme-columns">
			<div className="theme-column">
				<h4 className="header">NavBar</h4>
				<div className="theme-content">{renderFields(fields)}</div>
			</div>
		</div>
	);
};

NavBar.propTypes = {
	themeData: PropTypes.object,
};

export default NavBar;
